import React from 'react';
import { Portal } from 'react-portal';
import GeneralResponses from './GeneralResponses';

export default class GeneralResponsesOverlay extends React.Component {
  render() {
    return (
      <Portal>
        <GeneralResponses {...this.props} />
      </Portal>
    );
  }
}
